<img *ngIf="!isLoading && portalRegistrationPageData?.titleImage" [src]="portalRegistrationPageData.titleImage.content.umbracoFile.src" width="610" height="734" alt="Registration">

<app-skeleton *ngIf="isLoading" [height]="'100%'"/>>